import { OptionTypes } from '@/types';
import { Box, Button, Paper, Typography } from '@mui/material';
import { routes } from 'constants/index';
import { useBookingTimer } from 'context/BookingTimerContext';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export const Option: React.FC<OptionTypes> = ({
  name,
  icon,
  unitCode,
  btnName,
  locationCode,
}) => {
  const { startTimer } = useBookingTimer();
  const navinate = useNavigate();

  const navigateToSaearchEngine = (params: string) => {
    params = locationCode
      ? `${params}?locationCode=${locationCode.toLowerCase()}`
      : params;
    startTimer();
    navinate(`${routes.saerch}/${params}`);
  };

  return (
    <Paper
      className="option-style"
      onClick={() => navigateToSaearchEngine(unitCode)}
    >
      <Box mb={2} display="flex" justifyContent="center">
        <img src={icon} alt="Thrifty" />
      </Box>
      {/* <Typography variant="h6" gutterBottom>
        {name}
      </Typography> */}
      <Button variant="contained" color="primary">
        {btnName}
      </Button>
    </Paper>
  );
};
